// @mcpanel/core はサーバー用の関数も同じ入口から公開している。Web はそれらを呼ばないが、
// 開発サーバーでは node:* を読み込んだ時点で例外になるため、呼んだときだけ失敗する代わりを渡す。
const unavailable = (name: string) => () => {
  throw new Error(`${name} はブラウザでは使えません`);
};

export const createHash = unavailable('crypto.createHash');
export const createHmac = unavailable('crypto.createHmac');
export const createPublicKey = unavailable('crypto.createPublicKey');
export const timingSafeEqual = unavailable('crypto.timingSafeEqual');

const path = {
  join: unavailable('path.join'),
  resolve: unavailable('path.resolve'),
  posix: { join: unavailable('path.posix.join') },
};
export default path;
